define('blocks/header/header',['require','exports','module','jquery'],function(require, exports, module) {
    var $ = require('jquery');

    var HEADER_CLASS = 'header';
    var HEADER_SCROLL_MOD = 'scroll';
    var HEADER_EL = $('.' + HEADER_CLASS);
    var PAGE_CLASS = 'page';
    var PAGE_EL = $('.' + PAGE_CLASS);

    var headerHandlerTimeout;

    $(window).on('scroll resize', function() {
        clearTimeout(headerHandlerTimeout);
        headerHandlerTimeout = setTimeout(headerHandler, 0);
    });

    function headerHandler() {
        var scrollY = window.scrollY || document.documentElement.scrollTop;

        var classNeeded = scrollY >= 130;

        HEADER_EL[(classNeeded ? 'add' : 'remove') + 'Class'](HEADER_CLASS + '_' + HEADER_SCROLL_MOD);
        PAGE_EL[(classNeeded ? 'add' : 'remove') + 'Class'](PAGE_CLASS + '_' + HEADER_SCROLL_MOD);
    }

    headerHandler();
});

